import { Form } from '@kanda-libs/ks-component-ts';
import { Loader } from '@kanda-libs/ks-design-library';
import Success from 'pages/ApplyForFinance/Pages/YourInfo/Success';
import type { FunctionComponent } from 'react';
import AdditionalInfoForm from './AdditionalInfoForm';
import useAdditionalInfoForm from './useAdditionalInfoForm';

const AdditionalInfo: FunctionComponent = function () {
  const { isSubmitting, form, onSubmit, onError, success, job, showButton } =
    useAdditionalInfoForm();

  if (success) return <Success job={job} showButton={showButton} />;

  return (
    <Form
      id="additional-info"
      form={form}
      onSubmit={onSubmit as () => void}
      onError={(error) => {
        if (error) onError(error);
      }}
    >
      <AdditionalInfoForm isSubmitting={isSubmitting} />
      <Loader isLoading={isSubmitting} />
    </Form>
  );
};

export default AdditionalInfo;
